import { useEffect, useState } from 'react';

/** How long the launcher introduces itself as a labeled pill before minimizing. */
export const INITIAL_REVEAL_MS = 3000;

/**
 * True for the launcher's first few visible seconds, then false (pill →
 * circle). The countdown only runs while the launcher shows — mounting hidden
 * (sidebar open, home page) must not burn the intro before anyone sees it.
 */
export function useInitialReveal(isHidden: boolean) {
  const [isRevealed, setIsRevealed] = useState(true);

  useEffect(() => {
    if (isHidden || !isRevealed) return;
    const timer = window.setTimeout(() => setIsRevealed(false), INITIAL_REVEAL_MS);
    return () => window.clearTimeout(timer);
  }, [isHidden, isRevealed]);

  return isRevealed;
}
